<template>
  <svg
    :class="[this.customStyle ? $style.customSprite : $style.sprite]"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 46 46"
  >
    <g>
      <path
        :class="$style[fillClass]"
        d="M23,4C12.5,4,4,12.5,4,23h0H0.9l4.6,6.4l4.6-6.4H7h0c0-8.8,7.2-16,16-16s16,7.2,16,16s-7.2,16-16,16
	c-4.5,0-8.6-1.9-11.5-4.9l-2.2,2.1C12.8,39.8,17.6,42,23,42c10.5,0,19-8.5,19-19S33.5,4,23,4z"
      />
    </g>
  </svg>
</template>

<script type="text/ecmascript-6">
import Misc from 'src/utils/helper/misc'

export default {
  name: 'AnimationProcessing',

  props: {
    fill: {
      type: String,
      default: 'new-blue'
    },
    customStyle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    fillClass () {
      return `fill${this.fill}`
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.sprite {
	animation: rotation 2s infinite linear;
  transform-origin: 50% 50%;
}

.customSprite{
  animation: rotation 2s infinite linear;
  transform-origin: 50% 50%;
  width: 10%;
}

@each $color, $value in $colors {
  .fill#{$color} {
    fill: $value;
  }
}

@keyframes rotation {
  from { transform: rotate(0deg); }
  to { transform: rotate(-359deg); }
}
</style>
